export default "__VITE_ASSET__YB0vEw$x__"